import { request, success, failure, PAYMENT_METHOD_REQUEST } from './utilities';
import { getAllPaymentMethods, deletePaymentMethod, addNewPaymentMethod } from '../api';

export function getPaymentMethods() {
    return (dispatch) => {
        dispatch(request(PAYMENT_METHOD_REQUEST.GET_PAYMENT_METHOD_REQUEST));
        getAllPaymentMethods().then(
            response => {
                if (response.data.message === "Success") {
                    dispatch(success(PAYMENT_METHOD_REQUEST.GET_PAYMENT_METHOD_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(PAYMENT_METHOD_REQUEST.GET_PAYMENT_METHOD_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(PAYMENT_METHOD_REQUEST.GET_PAYMENT_METHOD_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    };
}

export function addPaymentMethod(paymentMethodData, close) {
    return (dispatch) => {
        dispatch(request(PAYMENT_METHOD_REQUEST.ADD_PAYMENT_METHOD_REQUEST));
        addNewPaymentMethod(paymentMethodData).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(PAYMENT_METHOD_REQUEST.ADD_PAYMENT_METHOD_SUCCESS, response.data.data))
                    if (close) {
                        close();
                    }
                }
                else {
                    dispatch(failure(PAYMENT_METHOD_REQUEST.ADD_PAYMENT_METHOD_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(PAYMENT_METHOD_REQUEST.ADD_PAYMENT_METHOD_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    };
}

export function editPaymentMethod(paymentMethodData) {
    return (dispatch) => {
        dispatch(request(PAYMENT_METHOD_REQUEST.EDIT_PAYMENT_METHOD_REQUEST));
        addNewPaymentMethod(paymentMethodData).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(PAYMENT_METHOD_REQUEST.EDIT_PAYMENT_METHOD_SUCCESS, response.data.data))
                }
                else {
                    dispatch(failure(PAYMENT_METHOD_REQUEST.EDIT_PAYMENT_METHOD_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(PAYMENT_METHOD_REQUEST.EDIT_PAYMENT_METHOD_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    };
}

export function removePaymentMethod(paymentMethodId) {
    return (dispatch) => {
        dispatch(request(PAYMENT_METHOD_REQUEST.DELETE_PAYMENT_METHOD_REQUEST));
        deletePaymentMethod(paymentMethodId).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(PAYMENT_METHOD_REQUEST.DELETE_PAYMENT_METHOD_SUCCESS, paymentMethodId))
                }
                else {
                    alert(response.data.message)
                    dispatch(failure(PAYMENT_METHOD_REQUEST.DELETE_PAYMENT_METHOD_FAILURE, response.data.message))
                }
            },
            error => {
                dispatch(failure(PAYMENT_METHOD_REQUEST.DELETE_PAYMENT_METHOD_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            }
        )
    }
}
